export default __webpack_public_path__ + "static/media/spotifyAn2.e1875e68.jpg";